const baseUrl = 'https://timesheet-api.stephenschafer.com';
// const baseUrl = 'http://localhost:9090'

const fetchOptions = (method, data) => {
	let token = window.localStorage.getItem('token');
	let headers = {
	};
	if(method === 'POST' || method === 'PUT') {
		headers['Content-Type'] = 'application/json';
	}
	if(token != null) {
		headers['Authorization'] = `Bearer ${token}`;
	}
	let options = {
		method: method,
		mode: 'cors',
		cache: 'no-cache',
		credentials: 'omit',
		headers: headers,
		redirect: 'follow',
		referrerPolicy: 'no-referrer'
	};
	if(data != null) {
		options.body = JSON.stringify(data);
	}
	return options;
};

export const login = (username, password) => {
	let url = `${baseUrl}/token/generate-token`;
	let data = {username: username, password: password};
	return fetch(url, fetchOptions('POST', data)).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const getEvents = date => {
	if(date == null) {
		return new Promise((resolve, reject) => {
			reject('date is null');
		});
	}
	let url = `${baseUrl}/raw-events/${date}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const getEvent = eventId => {
	if(eventId == null) {
		return new Promise((resolve, reject) => {
			reject('eventId is null');
		});
	}
	let url = `${baseUrl}/event/${eventId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const deleteEvent = eventId => {
	if(eventId == null) {
		return new Promise((resolve, reject) => {
			reject('eventId is null');
		});
	}
	let url = `${baseUrl}/event/${eventId}`;
	return fetch(url, fetchOptions('DELETE')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const duplicateEvent = eventId => {
	if(eventId == null) {
		return new Promise((resolve, reject) => {
			reject('eventId is null');
		});
	}
	let url = `${baseUrl}/dup/${eventId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const saveEvent = event => {
	if(event == null) {
		return new Promise((resolve, reject) => {
			reject('event is null');
		});
	}
	console.log("saveEvent", event);
	let id = event.id;
	let dateString = typeof event.date == "string" ? event.date : formatDate(event.date);
	let timeString = typeof event.time == 'string' ? event.time : formatTime(event.time);
	let datetimeString = dateString + "T" + timeString;
	let datetime = new Date(datetimeString);
	let data = {
		datetime: datetime,
		offset: 0,
		comment: event.comment,
		projects: event.projects
	};
	let url = `${baseUrl}/events/`;
	let method = 'POST';
	if(+id > 0) {
		data.id = id;
		method = 'PUT';
	}
	console.log('saveEvent.data', data);
	return fetch(url, fetchOptions(method, data)).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const getProjects = parentProjectId => {
	let url = parentProjectId == null ? `${baseUrl}/projects/root` : `${baseUrl}/projects/${parentProjectId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	}).then(data => {
		console.log('getProjects data', parentProjectId, data);
		if(data.status !== 200) {
			return new Promise((resolve, reject) => {
				reject(data);
			});
		}
		return new Promise((resolve, reject) => {
			resolve(data.result);
		});
	}, error => {
		return new Promise((resolve, reject) => {
			reject(error);
		});
	});
};

export const getProject = projectId => {
	if(projectId == null) {
		return new Promise((resolve, reject) => {
			reject('projectId is null');
		});
	}
	let url = `${baseUrl}/project/${projectId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const getProjectAncestry = projectId => {
	if(projectId == null) {
		return new Promise((resolve, reject) => {
			reject('projectId is null');
		});
	}
	let url = `${baseUrl}/project/ancestry/${projectId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const deleteProject = projectId => {
	if(projectId == null) {
		return new Promise((resolve, reject) => {
			reject('projectId is null');
		});
	}
	let url = `${baseUrl}/project/${projectId}`;
	return fetch(url, fetchOptions('DELETE')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const saveProject = project => {
	if(project == null) {
		return new Promise((resolve, reject) => {
			reject('project is null');
		});
	}
	console.log("saveProject", project);
	let url = `${baseUrl}/projects/`;
	let method;
	if(+project.id > 0) {
		method = 'PUT';
	}
	else {
		project.id = null;
		method = 'POST';
	}
	console.log('saveProject.data', project);
	return fetch(url, fetchOptions(method, project)).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
}

export const getLevelProjects = projectIds => {
	let projects = [];
	let parentProjectId = null;
	let getLevelProjectsInner = (projectIndex) => {
		if(projectIndex >= projectIds.length) {
			// done - add one for a new level
			projects[projectIndex] = {selectionList: []};
			return getProjects(parentProjectId).then(
				dataResults => {
					for(let dataResult of dataResults) {
						projects[projectIndex].selectionList
							.push(createProject(dataResult, parentProjectId));
					}
					return new Promise((resolve, reject) => {
						resolve(projects);
					});
				},
				error => {
					return new Promise((resolve, reject) => {
						reject(error);
					});
				}
			);
		}
		let projectId = projectIds[projectIndex];
		let last = projectIndex === projectIds.length - 1;
		projects[projectIndex] = {id: projectId, selectionList: [], last: last};
		return getProjects(parentProjectId).then(
			dataResults => {
				for(let dataResult of dataResults) {
					projects[projectIndex].selectionList
						.push(createProject(dataResult, parentProjectId));
				}
				parentProjectId = projectId;
				return getLevelProjectsInner(projectIndex + 1);
			},
			error => {
				return new Promise((resolve, reject) => {
					reject(error);
				});
			}
		);
	};
	return getLevelProjectsInner(0);
};

export const cloneLevelProjects = levelProjects => {
	let newLevelProjects = [];
	for(let levelProject of levelProjects) {
		// selectionList not cloned, but it doesn't need to be
		let newLevelProject = {
			id: levelProject.id,
			selectionList: levelProject.selectionList,
			last: levelProject.last
		};
		newLevelProjects.push(newLevelProject);
	}
	return newLevelProjects;
};

export const cloneAltProjects = (altProjects) => {
	let newAltProjects = [];
	for(let altProject of altProjects) {
		newAltProjects.push(cloneLevelProjects(altProject));
	}
	return newAltProjects;
};

export const handleLevelProjectChange = (e, levelProjects) => {
	console.log('handleProjectChange', e);
	const name = e.target.name;
	const value = e.target.value;
	if(!name.startsWith('project ')) {
		let message = `handleEventProjectChange unexpected target name: ${name}`;
		console.error(message);
		return new Promise((resolve, reject) => {
			reject({message: message});
		});
	}
	let parts = name.split(' ');
	let levelIndex = +parts[1];
	let clonedProjects = cloneLevelProjects(levelProjects);
	return handleProjectChange(levelIndex, +value, clonedProjects);
};

export const handleEventProjectChange = (name, value, altProjects) => {
	console.log('handleEventProjectChange', name, value);
	if(!name.startsWith('project ')) {
		let message = `handleEventProjectChange unexpected target name: ${name}`;
		console.error(message);
		return new Promise((resolve, reject) => {
			reject({message: message});
		});
	}
	let parts = name.split(' ');
	let altIndex = +parts[1];
	let levelIndex = +parts[2];
	let clonedProjects = cloneAltProjects(altProjects);
	return handleProjectChange(levelIndex, +value, clonedProjects[altIndex]).then(levelProjects => {
		clonedProjects[altIndex] = levelProjects;
		return new Promise((resolve, reject) => {
			resolve(clonedProjects);
		});
	});
};

export const handleProjectChange = (levelIndex, parentProjectId, levelProjects) => {
	console.log('handleProjectChange', levelIndex, parentProjectId, levelProjects);
	let clonedProjects = cloneLevelProjects(levelProjects);
	let projectObject = clonedProjects[levelIndex];
	if(projectObject == null) {
		let message = `No object found at level ${levelIndex}`;
		console.error(message);
		return new Promise((resolve, reject) => {
			reject({message: message});
		});
	}
	if(projectObject.id == null) {
		if(levelIndex !== clonedProjects.length - 1) {
			let message = `levelIndex should be ${clonedProjects.length - 1} but is ${levelIndex}`;
			console.error(message);
			return new Promise((resolve, reject) => {
				reject({message: message});
			});
		}
	}
	else {
		if(levelIndex > clonedProjects.length + 1) {
			let message = `levelIndex should be less than or equal to ${clonedProjects.length + 1} but is ${levelIndex}`;
			console.error(message);
			return new Promise((resolve, reject) => {
				reject({message: message});
			});
		}
	}
	if(parentProjectId === 0) {
		clonedProjects.length = levelIndex + 1;
		projectObject = {selectionList: []};
		clonedProjects[levelIndex] = projectObject;
		parentProjectId = null;
	}
	else {
		projectObject.id = parentProjectId;
		clonedProjects.length = levelIndex + 2;
		projectObject = {selectionList: []};
		clonedProjects[levelIndex + 1] = projectObject;
	}
	return getProjects(parentProjectId).then(
		dataResults => {
			console.log('getProjects', parentProjectId, dataResults);
			for(let dataResult of dataResults) {
				projectObject.selectionList.push(createProject(dataResult, parentProjectId));
			}
			console.log('clonedProjects', clonedProjects);
			return new Promise((resolve, reject) => {
				resolve(clonedProjects);
			});
		},
		error => {
			console.error('getProjects', error);
			return new Promise((resolve, reject) => {
				reject(error);
			});
		}
	);
};

export const parseDateISOString = s => {
	if(s == null) {
		return null;
	}
	let ds = s.split(/\D+/).map(s => parseInt(s));
	ds[1] = ds[1] - 1; // adjust month
	return new Date(ds[0], ds[1], ds[2]);
};

export const formatDate = date => {
	if(date == null) {
		return null;
	}
	let pad = num => {
		return (num < 10 ? '0' : '') + num;
	};
	// return date.toISOString().split('T')[0];
	return date.getFullYear() +
		'-' + pad(date.getMonth() + 1) +
		'-' + pad(date.getDate());
}

export const formatTime = date => {
	let pad = num => {
		return (num < 10 ? '0' : '') + num;
	};
	// return date.toISOString().split('T')[1];
	return pad(date.getHours()) +
		':' + pad(date.getMinutes()) +
		':' + pad(date.getSeconds());
}

export const formatDuration = value => {
	let pad = (n, width, z = "0") => {
		let ns = n + '';
		return ns.length >= width ? ns : new Array(width - ns.length + 1).join(z) + n;
	};
	let s = Math.floor(value / 1000);
	let m = Math.floor(s / 60);
	s -= m * 60;
	let h = Math.floor(m / 60);
	m -= h * 60;
	return "" + pad(h, 2) + ":" + pad(m, 2) + ":" + pad(s, 2);
};

export const incrementDate = (date, delta) => {
	if(date == null) {
		return null;
	}
	let newDate = new Date(date);
	newDate.setDate(newDate.getDate() + delta);
	return newDate;
};

export const isToday = (date) => {
	if(date == null) {
		return false;
	}
	if(typeof date == 'string') {
		date = parseDateISOString(date);
	}
	let today = new Date();
	if(date.getDate() === today.getDate() && 
		date.getMonth() === today.getMonth() && 
		date.getFullYear() === today.getFullYear()) {
		return true;
	}
	return false;
};

export const isYesterday = (date) => {
	if(date == null) {
		return false;
	}
	if(typeof date == 'string') {
		date = parseDateISOString(date);
	}
	let yesterday = new Date();
	yesterday.setDate(yesterday.getDate() - 1);
	if(date.getDate() === yesterday.getDate() && 
		date.getMonth() === yesterday.getMonth() && 
		date.getFullYear() === yesterday.getFullYear()) {
		return true;
	}
	return false;
};

export const isTomorrow = (date) => {
	if(date == null) {
		return false;
	}
	if(typeof date == 'string') {
		date = parseDateISOString(date);
	}
	let tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	if(date.getDate() === tomorrow.getDate() && 
		date.getMonth() === tomorrow.getMonth() && 
		date.getFullYear() === tomorrow.getFullYear()) {
		return true;
	}
	return false;
};

export const getDateCaption = (date) => {
	if(date == null) {
		return null;
	}
	if(typeof date == 'string') {
		date = parseDateISOString(date);
	}
	if(isToday(date)) {
		return 'Today';
	}
	if(isYesterday(date)) {
		return 'Yesterday';
	}
	if(isTomorrow(date)) {
		return 'Tomorrow';
	}
	return formatDate(date);
};

export const createProject = (dataResult, parentProjectId) => ({ 
	id: dataResult.id, 
	parentId: parentProjectId, 
	code: dataResult.code,
	minimumBillableHours: dataResult.minimumBillableHours,
	roundDailyHoursTo: dataResult.roundDailyHoursTo,
	bigtimeProjectId: dataResult.bigtimeProjectId,
	bigtimeTaskId: dataResult.bigtimeTaskId,
	bigtimeDescription: dataResult.bigtimeDescription
});

export const getWeekReport = (date, dayCount) => {
	if(date == null) {
		return new Promise((resolve, reject) => {
			reject('date is null');
		});
	}
	if(dayCount == null) {
		dayCount = 7;
	}
	let url = `${baseUrl}/report/week/${date}/${dayCount}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // this is a promise
	});
};

